import React from "react";
import Cookies from "universal-cookie";
import {
  XIcon,
  PresentationChartBarIcon,
  CashIcon,
  CollectionIcon,
  CogIcon,
} from "@heroicons/react/solid";
import { Link, useLocation } from "react-router-dom";
import useClickOutside from "../hooks/useClickOutside";
import { Button } from "./ui";
import { TbLayoutSidebarLeftCollapseFilled } from "react-icons/tb";
import { TbLayoutSidebarRightCollapseFilled } from "react-icons/tb";
import { ROLE } from "../config";

const cookies = new Cookies();

function Sidebar({ show, onClose, isExpanded, expandRetractSidebar }) {
  const role = cookies.get(ROLE);

  const sidebarOptions = [
    {
      name: "",
      label: "Dashboard",
      icon: <PresentationChartBarIcon className="w-5" />,
    },
    {
      name: "petty-cash/fund-requests",
      label: "Fund Requests",
      icon: <CashIcon className="w-5" />,
    },
    ...(role === "COMPANY_ADMIN"
      ? [
          {
            name: "petty-cash/entities",
            label: "Master",
            icon: <CollectionIcon className="w-5" />,
          },
        ]
      : []),
    ...(role === "COMPANY_ADMIN"
      ? [
          {
            name: "petty-cash/settings",
            label: "Settings",
            icon: <CogIcon className="w-5" />,
          },
        ]
      : []),
  ];

  const location = useLocation();

  const isActive = (path) =>
    location.pathname === path
      ? "bg-blue-100 font-semibold "
      : "hover:bg-blue-100 font-semibold";

  const sidebarRef = useClickOutside(() => {
    onClose();
  });

  return (
    <div
      ref={sidebarRef}
      className={`bg-white shadow-lg duration-500 ease-in-out lg:block h-[calc(100vh-4rem)] p-4 overflow-auto top-16 z-[1001] right-0 lg:left-0 fixed ${show ? "right-0 translate-x-0" : " translate-x-[500px] lg:translate-x-0"
        } ${isExpanded ? "w-64" : "w-20"}`}
    >
      <div>
        <div
          className={
            "hidden lg:flex " +
            (isExpanded ? "justify-end mb-3 " : "justify-center mb-5")
          }
        >
          <Button
            variant={"ghost"}
            size={"icon"}
            onClick={expandRetractSidebar}
          >
            {isExpanded ? (
              <TbLayoutSidebarLeftCollapseFilled className="w-6 h-6 text-primary" />
            ) : (
              <TbLayoutSidebarRightCollapseFilled className="w-6 h-6 text-primary" />
            )}
          </Button>
        </div>
        <div className="block lg:hidden text-right" onClick={onClose}>
          <Button size={"icon"} variant={"ghost"}>
            <XIcon className="w-6 h-6 text-white" />
          </Button>
        </div>

        <div className="gap-5 flex flex-col overflow-auto">
          {sidebarOptions.map((option) => (
            <Link
              to={`/${option.name}`}
              key={option.name}
              className={`flex text-primary items-center space-x-3 p-2 rounded-lg cursor-pointer ${isActive(
                `/${option.name}`
              )} ${isExpanded ? "justify-start" : "justify-center"}`}
            >
              {option.icon}
              {isExpanded && <span>{option.label}</span>}
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Sidebar;
